import { render, staticRenderFns } from "./evaluationStaffTrainingDetail.vue?vue&type=template&id=4fc9ef58"
import script from "./evaluationStaffTrainingDetail.vue?vue&type=script&lang=js"
export * from "./evaluationStaffTrainingDetail.vue?vue&type=script&lang=js"
import style0 from "./evaluationStaffTrainingDetail.vue?vue&type=style&index=0&id=4fc9ef58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports